import { render, staticRenderFns } from "./SwitchlangHeader.vue?vue&type=template&id=93a3c19e&scoped=true"
import script from "./SwitchlangHeader.vue?vue&type=script&lang=ts"
export * from "./SwitchlangHeader.vue?vue&type=script&lang=ts"
import style0 from "./SwitchlangHeader.vue?vue&type=style&index=0&id=93a3c19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a3c19e",
  null
  
)

export default component.exports